export interface CouponListType {
	vo: CouponListBodyType;
}

export interface CouponListBodyType {
	availableList: Coupon[];
	unavailableList: Coupon[];
}

export interface Coupon {
	idx: number;
	status: string;
	title: string;
	subTitle: string;
	expiredAt: string;
	usedAt: string;
	qrData: string;
	usingDescription: null | string;
	notice: null;
}

export interface EventListBodyType {
	id: number;
	title: string;
	createDate: number[];
	startDate: string;
	endDate: string;
	topText: string;
	bottomText: string;
	imageName: string;
	imgUrl: string;
	contentsImageName: string;
	contentsImageUrl: null | string;
	contentsImageName2X: string;
	contentsImageUrl2X: string;
	isActive: boolean;
	imgUrlFile: string | null;
	contentsImageUrlFile: string | null;
	contentsImageUrl2XFile: string | null;
}

export const CouponStatusTypeArray = ['USABLE', 'UNUSABLE', 'COMPLETED', 'EXPIRED'] as const;

type CouponStatusType = (typeof CouponStatusTypeArray)[number];
/**
 * Vaunce App 에서 스는 것이 아닌 POS 에서 사용하는 Coupon Type
 */
export interface VaunceCouponInfoType {
	couponId: number;
	couponName: string;
	couponStatus: CouponStatusType;
	couponUsagePlace: 'ONLINE' | 'OFFLINE' | 'ONLINE_OFFLINE';
	couponType: 'DISCOUNT' | 'PRODUCT';
	discountType: 'PERCENTAGE' | 'VALUE';
	discountValue: number;
	usableForAllCenter: boolean;
	storeWhiteList: number[];
	usableForAllProduct: boolean;
	productWhiteList: number[];
	isTargetOnTicket: boolean;

	memberId: number;
	username: string;
	telephone: string;

	used: Date;
	expired: Date;
}

export const isCouponUsable: Record<CouponStatusType, boolean> = {
	USABLE: true,
	UNUSABLE: false,
	COMPLETED: false,
	EXPIRED: false,
};

export const CouponStatusLabel: Record<CouponStatusType, string> = {
	USABLE: '사용 가능',
	UNUSABLE: '사용 불가능',
	COMPLETED: '사용 완료',
	EXPIRED: '만료',
};

export const CouponTypeLabel: Record<VaunceCouponInfoType['couponType'], string> = {
	DISCOUNT: '할인',
	PRODUCT: '상품',
};

export const CouponDiscountTypeLabel: Record<VaunceCouponInfoType['discountType'], string> = {
	PERCENTAGE: '퍼센트',
	VALUE: '값',
};
